import { render, staticRenderFns } from "./OrganisationPublicProfile.vue?vue&type=template&id=25312de6&scoped=true"
import script from "./OrganisationPublicProfile.vue?vue&type=script&lang=js"
export * from "./OrganisationPublicProfile.vue?vue&type=script&lang=js"
import style0 from "./OrganisationPublicProfile.vue?vue&type=style&index=0&id=25312de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25312de6",
  null
  
)

export default component.exports